import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private pageTitles: string[];

  pageTitles$: Subject<string[]> = new Subject<string[]>();

  getPageTitles(): string[] {
    return this.pageTitles;
  }

  setPageTitles(titles: string[]): void {
    this.pageTitles$.next(titles);
    this.pageTitles = titles;
  }
}
